import {
  COMPANY_SETTINGS_LOADED,
  COMPANY_SETTINGS_CLEAR,
  COMPANY_SINGLE_SETTING_LOADED,
  COMPANY_SINGLE_SETTING_CLEAR,
  COMPANY_NOTIFICATION_SETTINGS_LOADED,
  COMPANY_NOTIFICATION_SETTINGS_CLEAR,
  COMPANY_MAINTENANCE_SETTINGS_LOADED,
  COMPANY_MAINTENANCE_SETTINGS_CLEAR,
  COMPANY_UNITS_LOADED,
  COMPANY_UNITS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  companySettings: null,
  companySettingData: null,
  companyNotificationSettings: null,
  companyMaintenanceSettings: null,
  companyUnits: null,
};

const companySettings = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_SETTINGS_LOADED:
      return {
        ...state,
        companySettings: action.payload.settings,
      };

    case COMPANY_SETTINGS_CLEAR:
      return {
        ...state,
        companySettings: null,
      };

    case COMPANY_SINGLE_SETTING_LOADED:
      return {
        ...state,
        companySettingData: action.payload.setting,
      };

    case COMPANY_SINGLE_SETTING_CLEAR:
      return {
        ...state,
        companySettingData: null,
      };

    case COMPANY_NOTIFICATION_SETTINGS_LOADED:
      return {
        ...state,
        companyNotificationSettings: action.payload.settings,
      };

    case COMPANY_NOTIFICATION_SETTINGS_CLEAR:
      return {
        ...state,
        companyNotificationSettings: null,
      };

    case COMPANY_MAINTENANCE_SETTINGS_LOADED:
      return {
        ...state,
        companyMaintenanceSettings: action.payload.settings,
      };

    case COMPANY_MAINTENANCE_SETTINGS_CLEAR:
      return {
        ...state,
        companyMaintenanceSettings: null,
      };

    case COMPANY_UNITS_LOADED:
      return {
        ...state,
        companyUnits: action.payload.units,
      };

    case COMPANY_UNITS_CLEAR:
      return {
        ...state,
        companyUnits: null,
      };

    default:
      return state;
  }
};

export default companySettings;
